import AddUpdateAutomationModal from './modal/add_update_workflow';
import { AppDispatch } from '../../redux/store';
import { AutomationObject } from '../../params/redux/automation';
import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import DeleteWorkflowModal from './modal/delete_workflow';
import { duplicateAutomationThunk } from '../../redux/thunks/automation';
import { formatDateWithTime } from '../../helper';
import { grey } from '@mui/material/colors';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useState } from 'react';
import { addingConditionAutomationFlag, addingEmailAutomationFlag, addingSMSAutomationFlag, addingTimerAutomationFlag, settingSelectedAutomation, settingShowBuidlerFlag } from '../../redux/slices/automation';
import { Box, Divider, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { ContentCopy, Delete, Edit, FiberManualRecord, MoreVertRounded } from '@mui/icons-material';
import { settingNodes, settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';
// import { settingSelectedPipeline } from '../../redux/slices/pipeline';

interface WorkFlowCardComponentProps {
    automation: AutomationObject
}

const WorkFlowCardComponent = ({ automation }: WorkFlowCardComponentProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setMenuAnchor(event.currentTarget);
    };

    const handleMenuClose = (event: React.MouseEvent) => {
        event.stopPropagation();
        setMenuAnchor(null);
    };

    const selectedAutomationHandler = (workflow: AutomationObject) => {
        dispatch(settingSelectedNode(null));
        dispatch(settingSelectedEdge(null));
        dispatch(addingEmailAutomationFlag(false));
        dispatch(addingConditionAutomationFlag(false));
        dispatch(addingSMSAutomationFlag(false));
        dispatch(addingTimerAutomationFlag(false));
        dispatch(settingSelectedAutomation(workflow));
        dispatch(settingNodes(workflow.build_json || []));
        dispatch(settingShowBuidlerFlag(true));
    };

    const changeEventHandler = async (event: React.MouseEvent, value: 'edit' | 'delete' | 'duplicate') => {
        event.stopPropagation();
        setMenuAnchor(null);
        if (value === 'edit') {
            setShowModal(true);
            dispatch(settingSelectedAutomation(automation));
        }
        if (value === 'delete') {
            setShowDeleteModal(true);
            dispatch(settingSelectedAutomation(automation));
        }
        if (value === 'duplicate') {
            try {
                await dispatch(duplicateAutomationThunk({
                    automationId: automation.id,
                    client_id: id ? parseInt(id as string, 10) : 0
                }));
            } catch (e) {
                //
            }
        }
    };

    const onCloseModalHandler = () => {
        setShowModal(false);
        setShowDeleteModal(false);
        dispatch(settingSelectedAutomation(null));
    };

    return (
        <CardWrapper>
            <Box onClick={() => selectedAutomationHandler(automation)} sx={{ cursor: 'pointer' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" gap={1} alignItems="center">
                        <FiberManualRecord color={automation?.status === 'active' ? 'success' : 'error'} fontSize="small" /><Typography variant="body2" fontWeight="bold" color={automation.status === 'active' ? 'success' : 'error'}> {automation?.status === 'active' ? 'Active' : 'Inactive'}</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box px={2} borderRadius={1} width="max-content" py="0.1rem" bgcolor={brand[50]} color={brand[300]} height="max-content"><Typography variant="body1" fontWeight="500">{automation.build_json.length} Action{automation.build_json.length > 1 && 's'}</Typography></Box>
                        <IconButton onClick={(event) => handleMenuOpen(event)}>
                            <MoreVertRounded />
                        </IconButton>
                        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
                            <MenuItem onClick={(e) => changeEventHandler(e, 'edit')}>
                                <Box display="flex" alignItems="center" gap={2} color={grey[500]}><Edit fontSize="small" />
                                    <Typography variant="body1" color="textSecondary">Edit </Typography></Box>
                            </MenuItem>
                            <MenuItem onClick={(e) => changeEventHandler(e, 'duplicate')}>
                                <Box display="flex" alignItems="center" gap={2} color={grey[500]}><ContentCopy fontSize="small" /> <Typography variant="body1" color="textSecondary">Duplicate</Typography></Box>
                            </MenuItem>
                            <MenuItem onClick={(e) => changeEventHandler(e, 'delete')}>
                                <Box display="flex" alignItems="center" gap={2} color={grey[500]}><Delete fontSize="small" /> <Typography variant="body1" color="textSecondary">Delete</Typography></Box>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>
                <Typography variant="h6" fontWeight="bold" minWidth="200px" maxWidth="200px !important" color={brand[300]}>{automation.automation_name}</Typography>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} mt={1}>
                    <Box display="flex" alignItems="center" gap="5px">
                        <Typography variant="body2" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxWidth="200px">Pipeline: <b>{automation.pipeline_name || 'Not Assigned'}</b></Typography></Box>
                    <Box display="flex" alignItems="center" gap="5px">
                        <Typography variant="body2" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxWidth="200px">Stage: <b>{automation.stage_name || 'Not Assigned'}</b></Typography></Box>
                </Box>
                <Divider />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    <Box>
                        <Typography variant="body2" color="textDisabled">Created On:</Typography>
                        <Typography variant="body2" fontWeight="700" color="textSecondary">{formatDateWithTime(automation.created_at)}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="textDisabled">Edited On:</Typography>
                        <Typography variant="body2" fontWeight="700" color="textSecondary">{formatDateWithTime(automation.updated_at)}</Typography>
                    </Box>
                </Box>
            </Box>
            <AddUpdateAutomationModal open={showModal} onClose={onCloseModalHandler} />
            <DeleteWorkflowModal open={showDeleteModal} onClose={onCloseModalHandler} />
        </CardWrapper>
    );
};

export default WorkFlowCardComponent;